// D-0137 (Rafael 30/10): "Fornecedor Pagamento" vale POR ITEM no orçamento. Um fornecedor pode ficar misto; a Previsão
// e o Efetivo ficam com a parte da Agência e só mostram quem paga.

export const MSG_CLIENTE_BLOQUEADO = 'Este item já tem adiantamento ou o Financeiro já travou ou pagou a conta deste fornecedor: não pode virar Cliente. Para mudar, fale com o Financeiro.';

const idDe = (v) => (v && typeof v === 'object' ? (v.id ?? '') : (v ?? '')).toString();

const numero = (v) => {
    const s = String(v ?? '');
    const n = parseFloat(s.includes(',') ? s.replace(/\./g, '').replace(',', '.') : s);
    return Number.isFinite(n) ? n : 0;
};

// Mesma regra da API (OrcamentoController::itensComPagamentoViraramCliente): só a mudança conta, então linha nova e a
// que já é do cliente passam. `fornecedoresEmPagamento` = ids dos fornecedores com conta travada ou paga.
export function itemNaoPodeVirarCliente(subitem, fornecedoresEmPagamento = []) {
    if (!subitem || !subitem.id) return false;
    if (idDe(subitem.fornecedorpagamento).toLowerCase() === 'cliente') return false;
    if (numero(subitem.valor_adiantamento_item) > 0) return true;
    const fornecedor = idDe(subitem.fornecedor);
    return fornecedor !== '' && fornecedoresEmPagamento.some((f) => idDe(f) === fornecedor);
}

// O que o Efetivo mostra em "Quem paga" (só leitura; muda no orçamento, item a item).
export function quemPagaDoCard(forn) {
    const f = forn || {};
    if (f.quem_paga === 'cliente') {
        return { label: 'Cliente', tom: 'is-warn', texto: 'Todos os itens são pagos pelo cliente: não vai para o Financeiro. Para mudar, altere no orçamento.' };
    }
    if (f.quem_paga_misto) {
        return { label: 'Misto', tom: 'is-info', texto: 'Parte dos itens é paga pelo cliente. Aqui está só a parte da Agência. Para mudar, altere no orçamento.' };
    }
    return { label: 'Agência', tom: 'is-ok', texto: 'Pagamento realizado pela Access-MKT. Para mudar, altere no orçamento.' };
}
